import { NgClass } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
  Signal,
  computed,
  effect,
  inject,
  input,
  runInInjectionContext,
} from '@angular/core'

import { FlxStyleModule, FlxThemeModule, FlxWrapperStyleDirective } from '@flowx/angular-theme'
import { FlxIconModule } from '@flowx/angular-ui-toolkit'
import { EmptyStateTemplateConfig } from '@flowx/core-sdk'

import { getBoolExpressionSignal, getContentIcon, getDynamicPropSignal } from '../helpers'

@Component({
  selector: 'flx-empty-state-wrapper',
  hostDirectives: [
    { directive: FlxWrapperStyleDirective, inputs: ['flxWrapperStyle: templateConfig'] },
  ],
  imports: [NgClass, FlxThemeModule, FlxStyleModule, FlxIconModule],
  templateUrl: './empty-state-wrapper.component.html',
  styleUrl: './empty-state-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxEmptyStateWrapperComponent implements OnInit, AfterViewInit {
  readonly #injector = inject(Injector)
  readonly #flxWrapperStyle = inject(FlxWrapperStyleDirective)

  templateConfig = input.required<EmptyStateTemplateConfig>()

  displayOptions = computed(() => this.templateConfig().displayOptions)
  flowxProps = computed(() => this.displayOptions().flowxProps)

  // expressions
  isHidden: Signal<boolean>
  // dynamic props
  heading: Signal<string>
  description: Signal<string>

  readonly iconPath = computed(() => {
    const icon = this.flowxProps()?.icon
    if (!icon?.value) {
      return null
    }
    return getContentIcon(icon)
  })

  ngOnInit(): void {
    runInInjectionContext(this.#injector, () => {
      const props = this.flowxProps()
      this.isHidden = getBoolExpressionSignal(props.hide, this.templateConfig())
      this.heading = getDynamicPropSignal(props.heading || '', this.templateConfig())
      this.description = getDynamicPropSignal(props.description || '', this.templateConfig())
    })
  }

  ngAfterViewInit(): void {
    runInInjectionContext(this.#injector, () => {
      effect(() => {
        this.#flxWrapperStyle.toggleDisplay(this.isHidden())
      })
    })
  }
}
